/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { Select } from '@leverege/ui-redux';
import { Flex, Checkbox, Button } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('apiAccessKeyManagement.Columns');
function getColumns({
  targeted,
  targetedCount,
  apiAccessKeys,
  preActionsToolbar,
  postActionsToolbar,
  onCheck,
  onCheckAll,
  onCopyApiKey,
  onCopySecret,
  variants
}) {
  return [{
    id: 'targeted',
    resizable: false,
    sortable: false,
    accessor: d => Select.isSelected(targeted, d.id),
    Header: () => {
      const selected = targetedCount !== 0 && targetedCount === apiAccessKeys.length;
      return /*#__PURE__*/React.createElement(Flex, {
        variant: "rowS",
        align: "center"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        variant: "small",
        value: selected,
        onChange: onCheckAll
      }));
    },
    Cell: ({
      original,
      value
    }) => {
      return /*#__PURE__*/React.createElement(Flex, {
        align: "center"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        variant: "small",
        eventData: original,
        value: value,
        onChange: onCheck
      }));
    },
    maxWidth: 50
  }, {
    Header: t('preActions'),
    id: 'preActionsToolbar',
    sortable: false,
    accessor: item => {
      return /*#__PURE__*/React.cloneElement(preActionsToolbar, {
        ...preActionsToolbar.props,
        context: {
          ...preActionsToolbar.props.context,
          item
        }
      });
    },
    maxWidth: 100
  }, {
    Header: t('name'),
    sortable: false,
    id: 'name',
    accessor: 'name',
    maxWidth: 160
  }, {
    Header: t('apiKey'),
    sortable: false,
    id: 'apiKey',
    accessor: item => {
      return /*#__PURE__*/React.createElement(Button, {
        variant: variants.copyToClipboardSmall,
        eventData: item.id,
        onClick: onCopyApiKey
      }, item.id);
    },
    maxWidth: 320
  }, {
    Header: t('secret'),
    sortable: false,
    id: 'secret',
    accessor: item => {
      return /*#__PURE__*/React.createElement(Button, {
        variant: variants.copyToClipboardSmall,
        eventData: item.secret,
        onClick: onCopySecret
      }, t('copySecret'));
    },
    maxWidth: 190
  }, {
    Header: t('postActions'),
    id: 'postActionsToolbar',
    sortable: false,
    accessor: item => {
      return /*#__PURE__*/React.cloneElement(postActionsToolbar, {
        ...postActionsToolbar.props,
        context: {
          ...postActionsToolbar.props.context,
          item
        }
      });
    },
    maxWidth: 64
  },
  // Dummy column being used for its left side border.
  {
    id: 'dummy',
    sortable: false,
    accessor: 'dummy',
    maxWidth: 1
  }];
}
export { getColumns };